import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import SearchBar from "../../components/Common/SearchBar";
import Pagination from "../../components/Common/Pagination";
import RFQTable from "../../components/BuyerDashboard/Requirements/RFQTable";
import RequirementModal from "../../components/BuyerDashboard/Requirements/CreateRequirements";
import ProtectedButton from "../../components/RBAC/ProtectedButton";
import { useRFQData } from "../../components/BuyerDashboard/Requirements/useRFQData";
import { ApiHelper } from "../../utils/ApiHelper";
import { COMPANY_DETAIL_OF_USER } from "../../lib/API_KEYS";
import MultiSelectFilter from "../../components/Common/MultiSelectFilter";

export default function Requirements() {
  const location = useLocation();
  const hasSetInitialFilter = useRef(false);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState(["All"]);
  const [perPage, setPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [isCompanyApproved, setIsCompanyApproved] = useState(false);
  const [showCompleted, setShowCompleted] = useState(false);
  const [copyData, setCopyData] = useState(null);

  const {
    loading,
    requirements,
    totalPages,
    totalResults,
    availableStatuses,
    selectedRows,
    toggleAll,
    toggleRow,
  } = useRFQData(search, currentPage, perPage, statusFilter);

  const statusOptions = ["All", ...availableStatuses];

  // Apply filter from navigation state if provided (only once)
  useEffect(() => {
    if (location.state?.filterStatuses && !hasSetInitialFilter.current) {
      setStatusFilter(location.state.filterStatuses);
      hasSetInitialFilter.current = true;
      // Reset currentPage when filter changes from navigation
      setCurrentPage(1);
    }
  }, []);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const res = await new ApiHelper().FetchFromServer(
          ...COMPANY_DETAIL_OF_USER
        );

        if (res.data.status === 'Approved') setIsCompanyApproved(true)
      } catch (err) {
        console.error('Failed to fetch company data:', err);
        setIsCompanyApproved(false);
      }
    };
    fetchCompanyData();
  }, []);



  const handleCopy = (requirement) => {
    setCopyData(requirement);
    setShowModal(true);
  };

  if (!isCompanyApproved && !loading) return 'Your Details are not Approved Yet. We are Working on its approval.'

  return (
    <div className="container mt-4 border rounded p-3">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-1 flex-wrap gap-2">
        <h4 className="fw-bold">Requirements Overview</h4>
        <ProtectedButton
          permission="createRequirement"
          className="btn btn-dark text-white"
          style={{ backgroundColor: "#181D4C", border: "none" }}
          onClick={() => setShowModal(true)}
        >
          + Create new
        </ProtectedButton>
      </div>

      <p className="text-muted mb-2">
        Track, manage, and execute requirements with clarity and control
      </p>

      {showModal && <RequirementModal onClose={() => { setShowModal(false); setCopyData(null); }} initialData={copyData} />}

      <div className="container mt-4 border rounded p-3">

        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h5 className="fw-bold">Requirements</h5>
          <div className="d-flex gap-2 flex-wrap align-items-center">
            <MultiSelectFilter
              options={statusOptions}
              selectedValues={statusFilter}
              onChange={setStatusFilter}
              label="Status"
            />
            <SearchBar
              search={search}
              setSearch={setSearch}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>

        {/* Table */}
        <RFQTable
          loading={loading}
          data={requirements}
          currentPage={currentPage}
          perPage={perPage}
          selectedRows={selectedRows}
          toggleRow={toggleRow}
          toggleAll={toggleAll}
          onCopy={handleCopy}
        />

        {/* Pagination */}
        <Pagination
          perPage={perPage}
          setPerPage={setPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          totalPages={totalPages}
          totalResults={totalResults}
        />
      </div>
    </div >
  );
}
